import { IdType } from "react-table";
import { UserGroupDetail } from "lib/api";
import sortBy from "lodash.sortby";

export interface MemberDataRow extends Record<string, unknown> {
  id: string;
  assignee: boolean;
  email: string;
  name: string;
  surname: string;
  group: string;
}

export const joinGroups = (details?: UserGroupDetail[]): string => {
  if (details)
    return Array.from(
      new Set(
        sortBy(
          details.filter((detail: UserGroupDetail) => !detail.is_personal),
          [(group) => group.name.toLowerCase()]
        ).map((detail: UserGroupDetail) => {
          return detail.name;
        })
      )
    ).join(", ");
  return "";
};

export const addMember = (
  value: UserWithGroup,
  members: UserWithGroup[] | undefined
): UserWithGroup[] => {
  const newMembers = members ? [...members] : [];
  const index = newMembers.findIndex((member) => member.id === value.id);
  if (index !== -1) return newMembers;
  newMembers.push(value);
  return newMembers;
};

export const removeMember = (
  value: UserWithGroup,
  members: UserWithGroup[] | undefined
): UserWithGroup[] => members?.filter((member) => member.id !== value.id) || [];

export const extractSelection = (
  values: UserWithGroup[] | undefined
): Record<IdType<string>, boolean> => {
  const result: Record<IdType<string>, boolean> = {};
  values?.forEach((item) => {
    result[item.id] = true;
  });
  return result;
};
